import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import adminService from "../../Services/adminService";

class AdminNav extends Component {
  state = {
    pendingUsersAmount: "",
    intervalRef: null
  };

  componentDidMount() {
    adminService.getPendingUsers().then((res) => {
      if (res.success) {
        const pendingUsersAmount = res["pendingUsers"].length;
        this.setState({ pendingUsersAmount });
      }

      const intervalRef = setInterval(() => {
        adminService.getPendingUsers().then((res) => {
          if (res.success) {
            const pendingUsersAmount = res["pendingUsers"].length;
            this.setState({ pendingUsersAmount });
          }
        });
      }, config.refreshPendingMemberNotification);

      this.setState({ intervalRef });
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalRef);
  }

  render() {
    const roleType = localStorage.getItem("role");
    return (
      <div className="admin-nav-con">
        <Link to="/admin/users-manager">מציאת משתמשים</Link>
        <Link to="/admin/assignments">משימות</Link>
        <Link to="/admin/upload-videos">סרטוני הקורס</Link>

        {roleType === "admin" || roleType === "salesManager" ? (
          <>
            {this.state.pendingUsersAmount ? (
              <Link className="yellow-color" to="/admin/pending-users">
                ממתינים לאישור
                <div className="relative">
                  <div className="pending-amount">{this.state.pendingUsersAmount}</div>
                </div>
              </Link>
            ) : (
              <Link to="/admin/pending-users">ממתינים לאישור</Link>
            )}
          </>
        ) : null}

        <Link to="/admin/ending-memberships">סיומי מנוי</Link>
        <Link to="/admin/support">תמיכות פתוחות</Link>

        {roleType === "admin" || roleType === "systemTech" ? (
          <Fragment>
            <Link to="/admin/product-states">Statuses</Link>
            <Link to="/admin/fields-manager">שדות</Link>
            <Link to="/admin/docs-manager">מסמכים</Link>
          </Fragment>
        ) : null}
      </div>
    );
  }
}

export default AdminNav;
